import React from 'react';
export function PainAgitationSection() {
  return <section className="w-full py-12 px-4 bg-navy-dark bg-grain" data-id="element-139">
      <div className="max-w-[680px] mx-auto flex flex-col space-y-8 text-lg md:text-xl leading-relaxed font-light text-cream" data-id="element-140">
        <p data-id="element-141">You're not unlucky. You're intercepted.</p>

        <div className="border-l-2 border-warm-gold pl-6 py-2" data-id="element-142">
          <p className="text-cream/90" data-id="element-143">
            You go to church. You meditate every morning. You bought the
            crystals. You said the affirmations until your voice gave out. And
            for a moment, it felt like something was shifting... until it
            didn't. The promotion went to someone else. The relationship fell
            apart. The money never showed up. And the worst part? You watch
            people who don't do ANY of this spiritual work stumble into
            blessings like they're picking flowers.
          </p>
        </div>

        <p data-id="element-144">
          There's a specific moment most women recognize immediately — the
          moment you realize that no matter how hard you try, how positive you
          stay, or how much you pray... something keeps getting in the way.
        </p>

        <p data-id="element-145">
          It's not one big catastrophe. It's a pattern. A series of small
          collapses that add up to one exhausting feeling:
        </p>

        <p className="italic font-serif text-xl md:text-2xl text-cream/90" data-id="element-146">
          Why does it always go wrong for me?
        </p>

        <div className="w-full flex justify-end py-4" data-id="element-147">
          <p className="text-right italic font-serif text-2xl md:text-3xl text-rose max-w-[85%] leading-snug" data-id="element-148">
            "You work hard. You stay hopeful. And yet — the door closes. Again."
          </p>
        </div>

        <p data-id="element-149">
          Maybe it's a relationship that was almost perfect until it wasn't. A
          financial opportunity that fell through at the last minute. A
          friendship that turned cold for no reason. A body that started showing
          the stress you've been carrying for years.
        </p>

        <p data-id="element-150">
          You've tried to shake it off. You've bought the crystals. Said the
          affirmations. Lit the candles. And for a moment, it feels like things
          are shifting... until they don't.
        </p>

        <p data-id="element-151">What if the problem isn't your effort — or your faith?</p>

        <p data-id="element-152">
          What if there's a layer of interference that none of those things can
          reach?
        </p>

        <div className="w-full flex justify-start py-4" data-id="element-153">
          <p className="text-left italic font-serif text-2xl md:text-3xl text-gold max-w-[85%] leading-snug" data-id="element-154">
            "The static is real. And it has a frequency. Which means it can be
            cleared."
          </p>
        </div>

        <div className="bg-navy/60 border border-warm-gold/30 rounded-xl p-6 md:p-8 mt-4" data-id="element-155">
          <p className="text-warm-gold text-xs tracking-[0.2em] uppercase font-bold mb-4" data-id="element-156">
            HERE'S WHAT'S REALLY HAPPENING
          </p>
          <p className="text-cream/90 leading-relaxed" data-id="element-157">
            Your body has an electromagnetic field. When it gets disrupted — by
            stress, emotional residue, or what many cultures call "the evil eye"
            — your ability to attract good things gets intercepted. Think of it
            like a radio. You're broadcasting on the right station. But someone
            jammed the signal. That's why crystals alone don't work. That's why
            affirmations alone don't work. You're not clearing the interference.
            You're just turning up the volume on a jammed signal.
          </p>
        </div>
      </div>
    </section>;
}